import ReactGA4 from 'react-ga4';
import { addScriptDefault, setup } from 'meta-pixel';

const fbq = addScriptDefault();

const InitializeGoogleAnalytics = () => {
  ReactGA4.initialize([
    {
      trackingId: process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKINGID ?? '',
    },
    {
      trackingId: process.env.REACT_APP_GOOGLE_ADS_TRACKINGID ?? '',
    },
  ]);
  setup(fbq)
    .init(process.env.REACT_APP_META_ADS_TRACKINGID ?? '')
    .pageView();
};

const metaAnalyticsEventCompleteRegistration = () => {
  fbq('track', 'CompleteRegistration');
};

const TrackGoogleAnalyticsEvent = (category: string, action: string, label: string) => {
  // console.log('GA event:', category, ':', action, ':', label);
  ReactGA4.event({
    category,
    action,
    label,
  });
};

const LogPageView = (location: string, pageTitle?: string) => {
  ReactGA4.send({
    hitType: 'pageview',
    page: location,
    title: pageTitle ?? location,
  });
};

export default InitializeGoogleAnalytics;
export {
  InitializeGoogleAnalytics,
  TrackGoogleAnalyticsEvent,
  LogPageView,
  metaAnalyticsEventCompleteRegistration,
};
